export default __webpack_public_path__ + "static/media/mvp-prioritisation-4.f7152153.jpg";